// extracted by mini-css-extract-plugin
export var container__img = "DestacadosMobile-module--container__img--12c99";
export var container_destacados = "DestacadosMobile-module--container_destacados--c74b6";
export var imageSection = "DestacadosMobile-module--imageSection--2837f";
export var title = "DestacadosMobile-module--title--cee34";